// extracted by mini-css-extract-plugin
module.exports = {"table":"_5b10bb2305--table--AFcnf"};